import {
  AddressDetails,
  AutocompletePrediction,
  USPSAddressVerified,
} from "../types";
import { api } from "./api";

export const placesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addressAutocomplete: builder.query<AutocompletePrediction[], string>({
      query: (input: string) => ({
        method: "GET",
        url: `/api/places`,
        params: {
          input,
        },
      }),
    }),
    getAddressDetails: builder.query<AddressDetails, string>({
      query: (placeId: string) => ({
        method: "GET",
        url: `/api/places/${placeId}`,
      }),
    }),
    validatePlace: builder.query<USPSAddressVerified, string>({
      query: (placeId) => ({
        url: `/api/places/${placeId}/validate`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddressAutocompleteQuery,
  useGetAddressDetailsQuery,
  useValidatePlaceQuery,
} = placesApi;
